<template>
  <div>
    <BlTextAv weight="bold" variation="body-16" class="p-16 qa-landing-page-heading" tag="h1">
      Daftar Prakerja Online {{ getCurrentPeriod }} di Bukalapak!
    </BlTextAv>
    <BlTabsMv :tabs="tabs" :active-tab-name.sync="activeTabName" @update:activeTabName="onTabChange">
      <!-- Prakerja Tab Lembaga -->
      <BlTabNavMv slot="tab-nav-merchants" title="Lembaga Pelatihan" />
      <BlTabContentMv slot="tab-content-merchants">
        <PrakerjaListWithIconShimmer
          v-if="!highlightedMerchant.length && !isError.highlightedMerchant"
          :count="8"
          class="qa-shimmer-highlighted-merchants mt-20"
        />
        <template v-else>
          <PrakerjaListWithIconError
            v-if="isError.highlightedMerchant && !isAppLoading"
            info="Yah, infonya belum berhasil dimuat. Silakan coba muat ulang, ya."
            @reload="fetchHighlightedMerchant"
          />

          <BlFlexContainerMv v-else padding="16px" wrap="wrap">
            <PrakerjaListWithIcon
              :list="highlightedMerchant"
              more-button-link="merchants"
              class="qa-prakerja-tab-content-merchants w-full"
            />
          </BlFlexContainerMv>
        </template>
      </BlTabContentMv>
      <!-- End of Prakerja Tab Lembaga -->

      <!-- Prakerja Tab Kategori -->
      <BlTabNavMv slot="tab-nav-category" title="Kategori Kelas" />
      <BlTabContentMv slot="tab-content-category">
        <PrakerjaListWithIconShimmer v-if="!categoriesConfig.length && !isError.categoriesConfig" :count="8" class="mt-20" />

        <template v-else>
          <PrakerjaListWithIconError
            v-if="isError.categoriesConfig"
            info="Yah, infonya belum berhasil dimuat. Silakan coba muat ulang, ya."
            @reload="fetchCategoriesConfig"
          />

          <BlFlexContainerMv v-else padding="16px" wrap="wrap">
            <PrakerjaListWithIcon
              :list="categoriesConfig"
              :icon-size="40"
              more-button-link="categories"
              class="qa-prakerja-tab-content-categories w-full"
            />
          </BlFlexContainerMv>
        </template>
      </BlTabContentMv>
      <!-- End of Prakerja Tab Kategori -->
    </BlTabsMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlTabsMv, BlTabNavMv, BlTabContentMv} from '@bukalapak/bazaar-mweb-latest';

import PrakerjaListWithIcon from './PrakerjaListWithIcon.vue';
import PrakerjaListWithIconShimmer from './PrakerjaListWithIconShimmer.vue';
import PrakerjaListWithIconError from './PrakerjaListWithIconError.vue';

export default {
  name: 'PrakerjaCategoryAndMerchantTab',
  components: {
    BlTabsMv,
    BlTabNavMv,
    BlTabContentMv,
    PrakerjaListWithIcon,
    PrakerjaListWithIconShimmer,
    PrakerjaListWithIconError,
  },
  data() {
    return {
      activeTabName: 'merchants',
      tabs: ['merchants', 'category'],
    };
  },
  computed: {
    ...mapGetters(['isAppLoading']),
    ...mapGetters({
      highlightedMerchant: 'merchants/getHighlightedMerchant',
      categoriesConfig: 'categories/getCategoriesConfig',
      isError: 'getError',
    }),
    getCurrentPeriod() {
      const date = new Date();
      return date.toLocaleString('ID', {month: 'long', year: 'numeric'});
    },
  },
  mounted() {
    this.fetchHighlightedMerchant();
  },
  methods: {
    fetchHighlightedMerchant() {
      this.$store.dispatch('merchants/fetchHighlightedMerchant');
    },
    onTabChange() {
      if (!this.categoriesConfig.length) this.fetchCategoriesConfig();
    },
    fetchCategoriesConfig() {
      this.$store.dispatch('categories/fetchCategoriesConfig');
    },
  },
};
</script>
